<template>
  <chat-page-with-aside>
    <template #navheader>
      <header class="chathead">
        <button class="secondary" @click="showModal()">Exit</button>

        <p :class="activeSituation">
          My Situation
          <span>Clarifying the facts about my condition</span>
        </p>
        <p :class="activeOptions">
          My Options
          <span>Clarifying my treatment options</span>
        </p>
        <p :class="activeSupport">
          My Support
          <span>Clarifying who can help me</span>
        </p>
        <p :class="activeGoals">
          My Goals
          <span>Clarifying what's important to me</span>
        </p>
        <p :class="activeEvaluation">
          My Questions and Concerns
          <span>Clarifying what I want to discuss with my doctor</span>
        </p>
      </header>
    </template>

    <template #content>
      <button
        v-if="false"
        @click="toggleDebug"
        style="margin-left: 80%; margin-right: 0px;"
      >Toggle Debug</button>
      <div id="debug" :style="debugStyle">
        <button
          @click="$refs.chatbot.startChat(conversations.MySituation, undefined, resetSituation)"
        >My Situation</button>
        <button
          @click="$refs.chatbot.startChat(conversations.MyOptions, undefined, resetOptions)"
        >My Options</button>
        <button
          @click="$refs.chatbot.startChat(conversations.MyNetwork, undefined, resetNetwork)"
        >My Support</button>
        <button
          @click="$refs.chatbot.startChat(conversations.MyGoals, undefined, resetGoals)"
        >My Goals</button>
        <button
          @click="$refs.chatbot.startChat(conversations.Evaluation, undefined, resetEvaluation)"
        >Evaluation</button>
        <button @click="$refs.chatbot.clearChat()">Clear</button>
      </div>

      <modal v-show="isModalVisible" @close="closeModal" :showCloseIcon="false" >
        <template v-slot:modalName>
          <h2>Wait...</h2>
        </template>
        <template v-slot:modalHeaderText>
          <h4>We recommend that you finish the section you're working on before leaving the chat.</h4>
        </template>
        <template v-slot:modalBody>
          <h4 style="color:red">If you leave now, you'll need to re-start this section when you return.</h4>
        </template>

        <template v-slot:modalFooter>
          <button type="button" @click="closeModal" aria-label="Close modal">Return to chat</button>&nbsp;
          <button type="button" @click="saveAndExit" aria-label="Close modal">Leave chat</button>
        </template>
      </modal>

      <chatbot ref="chatbot" :conversationDescription="conversation" :startID="startID"></chatbot>
    </template>
  </chat-page-with-aside>
</template>

<style scoped lang="scss">
.chathead p.active {
  & + p + p {
    opacity: 0.8;
  }
  & + p + p + p {
    opacity: 0.5;
  }
  & + p + p + p + p {
    opacity: 0.2;
  }
}
</style>

<script>
import ChatPageWithAside from "@/components/ChatPageWithAside.vue";
import modal from '@/components/modal.vue';
import ChatBot from "@/components/ChatBot.vue";

import { mapMutations } from "vuex";
import { conversations } from "@/assets/conversations/index.js";

export default {
  name: "chat",

  props: {
    section: String,
    startID: String
  },

  data() {
    return {
      conversations: conversations,
      debug: false,
      isModalVisible: false
    };
  },

  methods: {
    ...mapMutations([
      "setCurrentSectionName",
      "resetSituation",
      "resetOptions",
      "resetNetwork",
      "resetGoals",
      "resetEvaluation"
    ]),

    toggleDebug() {
      this.debug = !this.debug;
    },


        showModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },

    saveAndExit() {
      this.setCurrentSectionName(this.section);
      this.$router.push("/profile");
    }
  },

  computed: {
    debugStyle() {
      if (this.debug) {
        return "display: block;";
      } else {
        return "display: none;";
      }
    },

    conversation() {
      switch (this.section) {
        case "situation":
          return this.conversations.MySituation;
          break;

        case "options":
          return this.conversations.MyOptions;
          break;

        case "network":
          return this.conversations.MyNetwork;
          break;

        case "goals":
          return this.conversations.MyGoals;
          break;

        case "evaluation":
          return this.conversations.Evaluation;
          break;
      }

      return undefined;
    },

    activeSituation: function() {
      return this.section == "situation" ? "active" : "";
    },
    activeOptions: function() {
      return this.section == "options" ? "active" : "";
    },
    activeSupport: function() {
      return this.section == "network" ? "active" : "";
    },
    activeGoals: function() {
      return this.section == "goals" ? "active" : "";
    },
    activeEvaluation: function() {
      return this.section == "evaluation" ? "active" : "";
    }
  },
  components: {
    chatbot: ChatBot,
    ChatPageWithAside,
    modal
  }
};
</script>
